import { useEffect, useState } from "react";

import "./VesselEmissionOverview.scss";

import { Switch } from "abs-ui-components";

import CarbonIntensityIndicator from "./CarbonIntensityIndicator/CarbonIntensityIndicator";
import EstimatedEmissions from "./EstimatedEmissions/EstimatedEmissions";

const VesselEmissionOverview = (props) => {
	const links = [
		"Carbon Intensity Indicator (CII)",
		"Estimated Emissions (EU-ETS)",
	];
	const [selectedLink, setSelectedLink] = useState(links[0]);

	const linkChangeHandler = (e) => {
		setSelectedLink(e);
		props?.handleSubTabChange(e);
	};

	useEffect(() => {
		props?.handleSubTabChange(selectedLink);
	}, []);

	return (
		<>
			<div>
				<Switch
					links={[
						"Carbon Intensity Indicator (CII)",
						"Estimated Emissions (EU-ETS)",
					]}
					onChange={linkChangeHandler}
					selected={selectedLink}
				></Switch>
			</div>

			<div className="mt-4">
				{selectedLink === "Carbon Intensity Indicator (CII)" && (
					<CarbonIntensityIndicator />
				)}

				{selectedLink === "Estimated Emissions (EU-ETS)" && (
					<EstimatedEmissions />
				)}
			</div>
		</>
	);
};

export default VesselEmissionOverview;
